<div id="payment-methods-wrapper" class="container">
  <h2>Payment Accounts</h2>

  <div class="row">
    <div class="col-md-3 col-sm-4">
      <app-payments-menu></app-payments-menu>
    </div>
    <div class="col-md-9 col-sm-8">
      <h3>Manage your primary & additional payment accounts</h3>
      <p>Your primary payment account is used by default to pay your bill.</p>

<div class="table2 col-md-12">
  <div class="row header">
    <div class="cell-lg">Date Created</div>
    <div class="cell-lg">Account</div>
    <div class="cell-me2">Type</div>
    <div class="cell-lg2">CC Expiration</div>
    <div class="cell-sm2">Primary</div>
    <div class="cell">Edit</div>
  </div>
  <div class="row" [class]="payment_account.expired || payment_account.expiring ? 'expired-row' : ''" *ngFor="let payment_account of payment_methods_model">
    <div class="cell-lg">
      {{ payment_account.created_date | amDateFormat:'l LT' }}
    </div>
    <div class="cell-lg">
      {{ payment_account.number_mask }}
    </div>
    <div class="cell-me2">
      {{ payment_account.bin === true ? 'Debit' : payment_account.account_type }}
    </div>
    <div class="cell-lg2">
      <span *ngIf="payment_account.cc_expiration_date">
                {{ payment_account.cc_expiration_date | amDateFormat:'MMMM YYYY' }}
              </span>
              <span *ngIf="payment_account.expired === true" class="badge badge-pill badge-danger">
                Expired
              </span>
              <span *ngIf="payment_account.expiring === true" class="badge badge-pill badge-danger">
                Expiring Soon
              </span>
    </div>
    <div class="cell-sm2">
      <div *ngIf="payment_account.expired === true">
        <a class="disabled" href="" (click)="setDefault(payment_account)">
          <fa-icon [icon]="payment_account.default_account ? faCheckSquare : faSquare"></fa-icon>
        </a>
      </div>
      <div *ngIf="payment_account.expiring === true">
        <a class="disabled" href="" (click)="setDefault(payment_account)">
          <fa-icon [icon]="payment_account.default_account ? faCheckSquare : faSquare"></fa-icon>
        </a>
      </div>
      <div *ngIf="payment_account.expired !== true && payment_account.expiring !== true">
        <a href="" (click)="setDefault(payment_account)">
          <fa-icon [icon]="payment_account.default_account ? faCheckSquare : faSquare"></fa-icon>
        </a>
      </div>
    </div>
    <div class="cell-sm">
      <a *ngIf="payment_account.account_type === 'Checking'"
                 [routerLink]="['/payment-methods', 'bank', payment_account.id]">
                <fa-icon [icon]="faPencilAlt"></fa-icon>
                <fa-icon *ngIf="notification(payment_account)?.priority==='Normal'" [icon]="icon_normal" [fixedWidth]="true" class="notification-indicator" [title]="notification(payment_account)?.title"></fa-icon>
                <fa-icon *ngIf="notification(payment_account)?.priority==='Urgent'" [icon]="icon_urgent" [fixedWidth]="true" class="notification-indicator" [title]="notification(payment_account)?.title"></fa-icon>
                <fa-icon *ngIf="notification(payment_account)?.priority==='Critical'" [icon]="icon_critical" [fixedWidth]="true" class="notification-indicator notification-critical" [title]="notification(payment_account)?.title"></fa-icon>
              </a>
              <a *ngIf="payment_account.account_type === 'CreditCard'"
                 [routerLink]="['/payment-methods', 'credit', payment_account.id]">
                <fa-icon [icon]="faPencilAlt"></fa-icon>
                <fa-icon *ngIf="notification(payment_account)?.priority==='Normal'" [icon]="icon_normal" [fixedWidth]="true" class="notification-indicator" [title]="notification(payment_account)?.title"></fa-icon>
                <fa-icon *ngIf="notification(payment_account)?.priority==='Urgent'" [icon]="icon_urgent" [fixedWidth]="true" class="notification-indicator" [title]="notification(payment_account)?.title"></fa-icon>
                <fa-icon *ngIf="notification(payment_account)?.priority==='Critical'" [icon]="icon_critical" [fixedWidth]="true" class="notification-indicator notification-critical" [title]="notification(payment_account)?.title"></fa-icon>
              </a>
    </div>

    <div *ngIf="payment_account.expired === true" class="expired-row expired-text" >
      This card is expired. Add a new payment method to continue. We’ll remove it 120 days after expiry.
    </div>
    <div *ngIf="payment_account.expiring === true" class="expired-row expired-text" >
      This card is expiring soon. Add a new payment method to continue. We’ll remove it 120 days after expiry.
    </div>
  </div>
</div>

      <br>
      <h3>Add a Payment Account</h3>
      <div class="row">
        <div class="col-sm-6" *ngIf="regulatory_model.credit_payments_enabled">
          <a [routerLink]="['/payment-methods', 'credit', 'new']" class="payment-box">
            <div class="payment-image-wrapper">
              <div class="credit-card-image"></div>
            </div>
            <div class="payment-text-wrapper">
              <div class="payment-text">Add a <b>debit or credit card</b></div>
            </div>
          </a>
        </div>
        <div class="col-sm-6" *ngIf="regulatory_model.bank_payments_enabled">
          <a [routerLink]="['/payment-methods', 'bank', 'new']" class="payment-box">
            <div class="payment-image-wrapper">
              <div class="bank-image"></div>
            </div>
            <div class="payment-text-wrapper">
              <div class="payment-text">Add a <b>bank account</b></div>
            </div>
          </a>
        </div>
      </div>

    </div>
  </div>
</div>
